export default {"src":"/_next/static/media/irrigation.7b66efff.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};